module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_165511_HDR-removebg-preview-d5a6a382e33e04106d7252b68bb7f80b.png";